import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { Toast } from './Toast';
import { ToastTypeEnum } from '@constant';

interface ToastItem {
  id: number;
  message: string | ReactNode;
  isVisible: boolean;
  toastType: ToastTypeEnum;
}

interface ToastContextType {
  showToast: (message: string | ReactNode, toastType?: ToastTypeEnum) => void;
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const [nextId, setNextId] = useState(1);

  const showToast = useCallback(
    (msg: string | ReactNode, toastType: ToastTypeEnum = ToastTypeEnum.DEFAULT) => {
      const newToast: ToastItem = {
        id: nextId,
        message: msg,
        isVisible: true,
        toastType
      };

      setToasts((prev) => {
        const updatedToasts = [...prev, newToast];
        if (updatedToasts.length > 3) {
          return updatedToasts.slice(1);
        }
        return updatedToasts;
      });

      setNextId((prev) => prev + 1);

      // 3초 후 Fade out 시작
      setTimeout(() => {
        setToasts((prev) => prev.map((toast) => (toast.id === newToast.id ? { ...toast, isVisible: false } : toast)));
        // Fade out 애니메이션 완료 후 제거
        setTimeout(() => {
          setToasts((prev) => prev.filter((toast) => toast.id !== newToast.id));
        }, 300);
      }, 3000);
    },
    [nextId]
  );

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toasts.map((toast, index) => (
        <Toast
          key={toast.id}
          message={toast.message}
          isVisible={toast.isVisible}
          toastType={toast.toastType}
          style={{ bottom: `${40 + (toasts.length - 1 - index) * 60}px` }}
        />
      ))}
    </ToastContext.Provider>
  );
};
